var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _bindInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/bind");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/regenerator", "@babel/runtime-corejs3/core-js/instance/bind", "@babel/runtime-corejs3/helpers/typeof", "@babel/runtime-corejs3/core-js/object/get-own-property-names", "@babel/runtime-corejs3/core-js/json/stringify", "@babel/runtime-corejs3/helpers/asyncToGenerator", "../utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/regenerator"), require("@babel/runtime-corejs3/core-js/instance/bind"), require("@babel/runtime-corejs3/helpers/typeof"), require("@babel/runtime-corejs3/core-js/object/get-own-property-names"), require("@babel/runtime-corejs3/core-js/json/stringify"), require("@babel/runtime-corejs3/helpers/asyncToGenerator"), require("../utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, _bindInstanceProperty2(global), global._typeof, global.getOwnPropertyNames, global.stringify, global.asyncToGenerator, global.utils);
    global.index = mod.exports;
  }
})(this, function (_exports, _regenerator, _bind, _typeof2, _getOwnPropertyNames, _stringify, _asyncToGenerator2, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _bind = _interopRequireDefault(_bind);
  _typeof2 = _interopRequireDefault(_typeof2);
  _getOwnPropertyNames = _interopRequireDefault(_getOwnPropertyNames);
  _stringify = _interopRequireDefault(_stringify);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  var _default = {
    init: function init(cb) {
      var me = this;
      window.addEventListener('unhandledrejection',
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee(event) {
          var _context;

          var stack, message, promiseErrorInfo, reason, desc, errorInfo, isNeedReport;
          return _regenerator.default.wrap(function _callee$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // reason可能是正常的字符串, 也可能会有message和stack信息
                  // 如果有的话, 就抓一下
                  stack = '';
                  message = '';
                  promiseErrorInfo = _utils._.get(event, ['promise'], {});
                  reason = _utils._.get(event, ['reason'], '');

                  try {
                    promiseErrorInfo = (0, _stringify.default)(promiseErrorInfo, (0, _getOwnPropertyNames.default)(promiseErrorInfo));

                    if ((0, _typeof2.default)(reason) === 'object') {
                      stack = _utils._.get(reason, ['stack'], '');
                      message = _utils._.get(reason, ['message'], '');

                      if (!message && !stack) {
                        reason = (0, _stringify.default)(reason);
                      }
                    }
                  } catch (e) {
                    promiseErrorInfo = _utils._.get(event, ['promise'], '') + ''; // 稳稳的 [object Promise]

                    reason = _utils._.get(event, ['reason'], '') + '';
                  }

                  desc = "Unhandled_Rejection:" + promiseErrorInfo;
                  errorInfo = {
                    desc: desc,
                    stack: stack,
                    reason: reason,
                    message: message,
                    type: 9
                  }; // 这里也去调用

                  _context2.next = 9;
                  return (0, _utils.customerErrorCheck)(me.config, (0, _bind.default)(_context = me.debugLogger).call(_context, me), errorInfo);

                case 9:
                  isNeedReport = _context2.sent;

                  if (!(!!isNeedReport === false)) {
                    _context2.next = 13;
                    break;
                  }

                  me.debugLogger("config.record.js_error_report_config.checkErrorNeedReport\u8FD4\u56DE\u503C\u4E3Afalse, \u8DF3\u8FC7\u6B64\u7C7B\u9519\u8BEF, \u9875\u9762\u62A5\u9519\u4FE1\u606F\u4E3A=>", {
                    desc: desc,
                    stack: stack
                  });
                  return _context2.abrupt("return");

                case 13:
                  cb && cb.call(me, "JS\u9519\u8BEF_Unhandled_Rejection", location.href, {
                    desc: desc,
                    reason: reason,
                    message: message,
                    stack: stack
                  });

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), true);
    }
  };
  _exports.default = _default;
});